import MegaOptionsContainer from "../../../../../Components/Forms&Table/Forms/FormControls/MegaOptions/MegaOptionsContainer";

const MegaOptions = () => {
  return <MegaOptionsContainer />;
};

export default MegaOptions;
